"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLink = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var getUnderlinedStyle_1 = require("./getUnderlinedStyle");
var getRoundedStyle_1 = require("./getRoundedStyle");
var HeaderLink = function (_a) {
    var underlined = _a.underlined, isRounded = _a.isRounded, className = _a.className, children = _a.children, linkProps = __rest(_a, ["underlined", "isRounded", "className", "children"]);
    var _b = (0, useHeaderProps_1.useHeaderProps)(), LinkComponent = _b.LinkComponent, colorSet = _b.colorSet;
    var highlightStyle = {
        bg: colorSet === null || colorSet === void 0 ? void 0 : colorSet.backgroundHighlight,
    };
    var baseStyle = {
        p: 2,
        h: 9,
        fontSize: 'md',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 3,
        color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text,
        textDecoration: 'none',
    };
    return (React.createElement(LinkComponent, __assign({ className: underlined ? className + ' underlined' : className, position: "relative" }, baseStyle, (underlined && (0, getUnderlinedStyle_1.getUnderlinedStyle)(colorSet === null || colorSet === void 0 ? void 0 : colorSet.accent1)), (isRounded && (0, getRoundedStyle_1.getRoundedStyle)()), linkProps, { _hover: highlightStyle }), children));
};
exports.HeaderLink = HeaderLink;
